module.exports = __webpack_public_path__ + "assets/61611d073767a737851bc4806f4b8dfb.svg";